import axios from "axios";

const url = process.env.REACT_APP_API_URL_DASHBOARD_UP;

const dashboardFetch = async (endpoint) => {
  const response = await axios.get(`${url}${endpoint}`);
  return response.data;
};

export default class LandingService {
  static async getRekapIzinPrimer(startDate, endDate, limit) {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (limit !== undefined) params.append("limit", limit.toString());

    return dashboardFetch(
      `/primer/rekap-izin-primer?${params.toString()}`
    );
  }

  static async getPropinsiPerIzin(startDate, endDate, kdIzin, limit) {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (kdIzin) params.append("kdIzin", kdIzin);
    if (limit) params.append("limit", limit.toString());

    return dashboardFetch(
      `/primer/propinsi-per-izin?${params.toString()}`
    );
  }

  // getRekapPermohonan(tglAwal, tglAkhir, limit) {
  //       return axios.get(`${url}/primer/rekap-izin-primer`, {
  //           params: {
  //               startDate: tglAwal,
  //               endDate: tglAkhir,
  //               ...(limit !== undefined && { limit })
  //           }
  //       });
  //   }

  //   getPropinsiPerIzin(startDate, endDate, kdIzin, limit) {
  //       return axios.get(`${url}/rimer/propinsi-per-izin`, {
  //           params: {
  //               startDate,
  //               endDate,
  //               kdIzin,
  //               ...(limit !== undefined && { limit })
  //           }
  //       });
  //   }
}